/* global feag */

const toggleLike = () => {
  const btns = document.querySelectorAll('[data-like-toggle]');

  if (btns.length) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < btns.length; i++) {
      btns[i].addEventListener(
        'click',
        // eslint-disable-next-line no-unused-vars
        e => {
          const counter = btns[i].querySelector('[data-like-counter]');
          btns[i].classList.add('disabled');

          const formData = new FormData();
          formData.append('action', 'IntranetToggleLike');
          formData.append('post_id', btns[i].dataset.postId);
          formData.append('user_id', btns[i].dataset.userId);

          const request = new XMLHttpRequest();

          request.open('POST', feag.ajaxurl, true);
          // eslint-disable-next-line func-names
          request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
              if (this.responseText > counter.innerText) {
                btns[i].classList.add('is-filled');
              } else {
                btns[i].classList.remove('is-filled');
              }
              counter.innerHTML = this.responseText;
              btns[i].classList.remove('disabled');
            }
          };
          request.send(formData);
        },
        false,
      );
    }
  }
};

toggleLike();
